import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { MONEY_CONVERT_DATA } from '../../redux/actions/index'
import down from '../../assets/down.svg'
import up from '../../assets/up.svg'

export default function ProviderCard({ sendingAmount, sendingRate }) {
  const dispatch = useDispatch()

  const convertedData = useSelector(
    (state) => state?.covertedData?.covertedData
  )

  const [scopeXAmout, setScopeXAmout] = useState(0)
  useEffect(() => {
    setScopeXAmout(sendingAmount * sendingRate)
  }, [])

  useEffect(() => {
    dispatch({ type: MONEY_CONVERT_DATA, sendingAmount })
    setScopeXAmout(sendingAmount * sendingRate)
  }, [sendingAmount, sendingRate])

  useEffect(() => {
    AOS.init()
  })

  const allowedProvider = ['wise', 'remitly', 'western union', 'xoom', 'skrill']

  const checkProvider = (provider) => {
    return allowedProvider.includes(provider?.name.toLowerCase())
  }

  return (
    <div className='w-full relative pt-10 -mt-26 lg:-mt-20 px-4'>
      <div className='absolute top-0 right-0 -z-50'>
        <div className='circle hidden lg:block justify-end'></div>
      </div>
      <div className='max-w-screen-xl mx-auto  mb-10 align-center'>
        <div className='sm:w-9/12 mx-auto '>
          <div className='flex flex-col'>
            <div>
              <div className='my-10 text-center'>
                <h1 className='font-bold text-3xl'>
                  Compare our money transfer rates
                </h1>
                <h2 className='text-2xl'>
                  We are completely transparent and charge NO hidden fees to our
                  customers.
                </h2>
              </div>
            </div>

            <div
              className='overflow-x-auto shadow-lg'
              data-aos='fade-in'
              data-aos-offset='200'
            >
              <div className='inline-block  align-middle '>
                <div className='overflow-hidden '>
                  <table className=' divide-y divide-gray-200 sm:table-fixed w-full'>
                    <thead>
                      <tr>
                        <th
                          scope='col'
                          className='py-3 px-6 text-xl font-large tracking-wider text-left text-white bg-themeColor '
                        >
                          Provider
                        </th>
                        <th
                          scope='col'
                          className='py-3 px-6 text-xl font-large tracking-wider text-left text-white bg-themeColor '
                        >
                          <p>
                            Received INR
                            <br />
                            <span className='font-medium text-slate-300'>
                              Send{' '}
                              {sendingAmount && (+sendingAmount).toFixed(2)} EUR
                            </span>
                          </p>
                        </th>
                        <th
                          scope='col'
                          className='py-3 px-6 text-xl font-large tracking-wider text-left text-white bg-themeColor hidden lg:table-cell'
                        >
                          Exchange rate
                          <br />
                          <span className='font-medium text-slate-300'>
                            (1 EUR → INR)
                          </span>
                        </th>
                        <th
                          scope='col'
                          className='py-3 px-6 text-xl font-large tracking-wider text-left text-white bg-themeColor hidden lg:table-cell'
                        >
                          Transfer fee
                        </th>
                      </tr>
                    </thead>
                    <tbody className='bg-white divide-y divide-gray-300 '>
                      {scopeXAmout && (
                        <tr
                          key='scopx-card'
                          className='shadow-sm text-3xl bg-white'
                        >
                          <td className='py-4 px-6 text-xl font-medium text-gray-900 whitespace-nowrap'>
                            <span>
                              <img
                                className='w-3/4 h-14 object-scale-down object-left'
                                src='images/logo_green.png'
                                alt='Scopex logo'
                                width='100%'
                                height='100%'
                              />
                            </span>
                            {/* {val?.name} */}
                          </td>
                          <td className='py-4 px-6 text-xl font-large font-bold text-gray-800 whitespace-nowrap  '>
                            <span style={{ color: '#84A096' }}></span>{' '}
                            {scopeXAmout.toFixed(2)} INR
                            <br />
                            {/* <span className="text-green-500 text-sm font-bold">
                              0.00
                            </span> */}
                          </td>
                          <td className='py-4 px-6 text-xl font-large text-gray-800 whitespace-nowrap font-bold hidden lg:table-cell'>
                            {sendingRate.toFixed(2)}
                          </td>
                          <td className='py-4 px-6 text-xl font-large text-gray-800 whitespace-nowrap font-bold hidden lg:table-cell'>
                            0 EUR
                          </td>
                        </tr>
                      )}

                      {convertedData?.providers
                        ?.sort(
                          (a, b) =>
                            b.quotes[0].receivedAmount -
                            a.quotes[0].receivedAmount
                        )
                        ?.filter(checkProvider)
                        .map((val, index) => (
                          <tr key={'card-' + index}>
                            <td className='py-4 px-6 text-xl font-medium text-gray-900 whitespace-nowrap '>
                              <span>
                                <img
                                  className='w-24 h-16 object-scale-down object-left'
                                  src={val?.logo}
                                  alt='logo'
                                  width='100%'
                                  height='100%'
                                />
                              </span>
                            </td>
                            <td className='py-4 px-6 text-xl font-medium text-gray-800 whitespace-nowrap'>
                              <span style={{ color: '#84A096' }}></span>{' '}
                              {val?.quotes[0]?.receivedAmount.toFixed(2)} INR
                              <br />
                              <span
                                className={`${
                                  val?.quotes[0]?.receivedAmount.toFixed(2) >
                                  scopeXAmout
                                    ? 'text-green-400'
                                    : 'text-red-400'
                                } text-sm font-bold flex items-center`}
                              >
                                <img
                                  src={
                                    val?.quotes[0]?.receivedAmount.toFixed(2) >
                                    scopeXAmout
                                      ? up
                                      : down
                                  }
                                  alt={`${
                                    val?.quotes[0]?.receivedAmount.toFixed(2) >
                                    scopeXAmout
                                      ? 'up-arrow'
                                      : 'down-arrow'
                                  }`}
                                  className={`w-3 h-3 m-1`}
                                />

                                {(
                                  val?.quotes[0]?.receivedAmount.toFixed(2) -
                                  scopeXAmout
                                )
                                  .toFixed(2)
                                  .replace('-', '')}
                              </span>
                            </td>
                            <td className='py-4 px-6 text-xl font-medium text-gray-800 whitespace-nowrap hidden lg:table-cell'>
                              {val?.quotes[0]?.rate.toFixed(2)}
                            </td>
                            <td className='py-4 px-6 text-xl font-medium text-gray-800 whitespace-nowrap hidden lg:table-cell'>
                              {val?.quotes[0]?.fee} EUR
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
